import React from 'react';
import { motion } from 'framer-motion';
import styles from './Question.module.css';

import logo from '../../assets/images/logo.png';

import left from '../../assets/images/left.png';
import right from '../../assets/images/right.png';

import posterDefault from '../../assets/images/poster.png';
import bgDefaultVideo from '../../assets/video/bgVideo.mp4';

function Question({ question, questionFontSize, bgVideo, bgPoster }) {
  const titleArr = question.split('\n').map((el) => el.replace('\r', ''));

  return (
    <div className={styles.questionWrapper}>
      <motion.img
        src={logo}
        alt="logo"
        className={styles.logo}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      />

      <div className={styles.questionBlock}>
        {titleArr[0] && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.4, 1] }}
            transition={{ times: [0, 0.85, 1], duration: 1.5 }}>
            <div className={styles.firstLine}> {titleArr[0]}</div>
          </motion.div>
        )}
        {titleArr[1] && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.2, 0.95] }}
            transition={{ times: [0, 0.85, 1], duration: 1.66, delay: 0.43 }}>
            <div className={styles.secondLine}>{titleArr[1]}</div>
          </motion.div>
        )}
        {titleArr[2] && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.2, 0.9] }}
            transition={{ times: [0, 0.85, 1], duration: 1.66, delay: 0.93 }}>
            <div className={styles.thirdLine}>{titleArr[2]}</div>
          </motion.div>
        )}
      </div>

      <motion.img
        src={left}
        initial={{ x: '-50%', y: '-2%' }}
        animate={{ x: '-20%', y: '0' }}
        transition={{ duration: 1, ease: 'easeOut' }}
        alt="playerLeft"
        className={styles.left}
      />

      <motion.img
        src={right}
        initial={{ x: '50%', y: '-2%' }}
        animate={{ x: '0%', y: '0' }}
        transition={{ duration: 1, ease: 'easeOut' }}
        alt="playerRight"
        className={styles.right}
      />

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.videoBg}
        poster={bgVideo === '1' ? posterDefault : bgPoster}>
        <source
          src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
          type="video/mp4"></source>
      </video>
    </div>
  );
}

export default Question;
